import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

@Component({
  selector: 'app-anexo-modal',
  templateUrl: './anexo-modal.component.html',
  styleUrls: ['./anexo-modal.component.scss']
})
export class AnexoModalComponent implements OnInit {

  public config: PerfectScrollbarConfigInterface = {};

  selectedFile: File;
  idCupom = '';


  constructor(public dialogRef: MatDialogRef<AnexoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.idCupom = this.data.idCupom;
  }

  anexar() {
    this.dialogRef.close(this.selectedFile);
  }

  onFileChanged(event) {
    this.selectedFile = event.target.files[0];
  }

  fechar() {
    this.dialogRef.close();
  }

}
